import { usePathname } from "next/navigation";

import { links } from "@/data/links";
import { useLang } from "@/hooks/use-lang";

export const useAuthUrls = () => {
  const { lang } = useLang();
  const pathname = usePathname();

  const loginUrl = `/${lang}${links.authLogin}?redirect=${encodeURIComponent(
    pathname
  )}`;
  const signupUrl = `/${lang}${links.authSignup}?redirect=${encodeURIComponent(
    pathname
  )}`;

  return {
    loginUrl,
    signupUrl,
  };
};
